/**
 * 앱이 접속할 수 있는 도메인 목록 — $j.F.App.changeHost(host, tag) 로 보내는 값의 정본.
 * tag 는 앱에 함께 전달하는 구분 라벨. 목록에 없는 호스트는 보내지 않는다 (.ai/app-protocol.md).
 *
 * 쓰는 곳: Pages/Mobile/DevBridge (장비불러), F/Devil/DevBridge (악덕알리미)
 */
export default [
    { host: 'https://jbbuller.kr',       tag: '운영' },
    { host: 'https://stage.jbbuller.kr', tag: '스테이지' },
    { host: 'https://qa.jbbuller.net',   tag: 'QA' },
    { host: 'https://qa2.jbbuller.net',  tag: 'QA2' },
    { host: 'https://qa3.jbbuller.net',  tag: 'QA3' },
    { host: 'https://jbbuller.net',      tag: '개발1' },
    { host: 'https://dev.jbbuller.net',  tag: '개발2' },
    { host: 'https://yoon.jbbuller.net', tag: '윤' },
    { host: 'https://hong.jbbuller.net', tag: '홍' },
    { host: 'https://gm.jbbuller.net',   tag: '박' },
    { host: 'https://yg.jbbuller.net',   tag: '유' },
];
